import React from 'react';
import { Securities } from 'api';
import { ValuationApproachModel } from 'api/models/ValuationApproachModel';
import { Format } from 'common/types/format';
import { ConfigurationSpreadsheets } from 'common/types/scalarSpreadsheet/scalarSpreadsheet';

export type Spreadsheets = {
  [key: string]: ConfigurationSpreadsheets;
};

export interface BacksolveContextTypes {
  approach: ValuationApproachModel;
  gpcApproach: ValuationApproachModel;
  spreadsheets: Spreadsheets;
  gpcSheets: Spreadsheets;
  onMarketAdjustmentLedgerChange: (data: any) => void;
  measurementDate: string;
  format: Format;
  formatDispatch: () => void;
  securityList: Securities[];
}

const BacksolveContext = React.createContext<BacksolveContextTypes>({} as BacksolveContextTypes);

export default BacksolveContext;
